import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { ICategory, ICategoryMenu } from '@interfaces/category';
import type { IMenuLayout } from '@interfaces/menuLayout';

@Injectable({
	providedIn: 'root',
})
export class MenuLayoutService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getMenuLayout() {
		return this._http.get<IMenuLayout>('preferences/menus');
	}

	// --- PUT endpoints ---
	updateMenuLayout(menuLayout: IMenuLayout) {
		return this._http.put<IMenuLayout>(`preferences/menus`, menuLayout);
	}

	updateSelectedCategories(categories: ICategoryMenu[]) {
		return this._http.put<ICategory[]>('categories', categories);
	}
}
